import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { walletState } from "../../context/walletState";
import { useLiquidity } from "../../hooks/useLiquidity";
import { useConnectWallet } from "../../hooks/useTxnClient";
import GetBalance from "../common/balance/GetBalance";
import SwapHeaderMenu from "../swap/SwapHeaderMenu";
import { useConfig } from "../../hooks/useConfig";
import { balanceState } from "../../context/balanceState";
import { useToken } from "../../hooks/useToken";
import LoadingModal from "../common/loading-modal/LoadingModal";
import { queryClientState } from "../../context/queryClientState";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import CustomLinkToast from "./CustomLinkToast";
import { configState } from "../../context/configState";

const AddLiquidity = ({getUserAmt, setIsModalOpen}: any) => {
  const location = useLocation();
  const { queryClient } = useRecoilValue(queryClientState);
  const { pairs, token1, token2 } = location.state;
  const [input1, setinput1] = useState("");
  const [input2, setinput2] = useState("");
  const [ratio, setRatio] = useState("-1");
  const { doAddLiquidity, getPoolTotalAmount } = useLiquidity();
  const { address } = useRecoilValue(walletState);
  const connectWallet = useConnectWallet();
  const { getPool } = useConfig();
  const navigate = useNavigate();
  const [disabled, setdisabled] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [dataRefetch, setdataRefetch] = useState(false);

  const userliqMap = useRecoilValue(configState);
  const setuserLiqMap = useSetRecoilState(configState);

  const handleAddLiquidity = async () => {
    setIsLoading(true);
    const addRes = await doAddLiquidity(
      pairs.pair_name,
      input1,
      input2,
      "0.05"
    );
    setIsLoading(false);

    // only for testnet
    const txnHash = addRes.transactionHash ? addRes.transactionHash : "";
    toast.info(<CustomLinkToast hash={txnHash} />);

    const updateMap = async () => {
      // let userMap: Record<string, boolean> = {};
      const { userMap } = userliqMap;
      userMap[pairs.pair_name] = true;
      setuserLiqMap({
        ...userliqMap,
        userMap: userMap,
      });
    };
    if(!addRes.code && addRes!==undefined){
      updateMap();
    }
    getUserAmt();
    setdataRefetch(!dataRefetch);
    setIsModalOpen(false);
    // navigate(-1);
  };

  const getPools = async () => {
    const { firstTokenAmount, secondTokenAmount } = await getPoolTotalAmount(
      pairs.pair_name
    );
    console.log(firstTokenAmount, secondTokenAmount)
    if (Number(firstTokenAmount) >= 0 && Number(secondTokenAmount) > 0) {
      setdisabled(false);
      setRatio(
        (Number(firstTokenAmount) / Number(secondTokenAmount)).toString()
      );
    } else {
      setdisabled(false);
      setRatio("1");
    }
  };

  useEffect(() => {
    getPools();
    fetchBalance(false);
  // }, [queryClient]);
  }, []);

  const handleinput1 = (e: any) => {
    if(ratio === "-1"){
      setdisabled(true);
    }
    else {setdisabled(false);
    setinput1(e.target.value);
    getPools();
    setinput2((Number(e.target.value) / Number(ratio)).toFixed(6));}
  };
  const handleinput2 = (e: any) => {
    if(ratio === "-1"){
      setdisabled(true);
    }
    else {setdisabled(false);
    setinput2(e.target.value);
    getPools();
    setinput1((Number(e.target.value) * Number(ratio)).toFixed(6));}
  };

  const { getBalance } = useToken();

  const [maxBal, setMaxBal] = useState<string | null | undefined>("0");
  const fetchBalance = async (isRefreshing?: boolean) => {
    const balance = await getBalance(token1.display_denom, isRefreshing);
    setMaxBal(balance);
  };

  const handleMax = () => {
    setinput1(Number(maxBal)?.toString());
    setinput2((Number(maxBal) / Number(ratio)).toString());
  };
  const [token1Bal, setToken1Bal] = useState(0);
  const [token2Bal, setToken2Bal] = useState(0);
  return (
    <div className="addliquidity-wrapper">
      <div className="token1-wrapper">
        <div className="token_info">
          <div>
            {<img src={token1?.logo_URIs.png} alt="NOimg" height={50} />}
          </div>
          <span>{token1.display_denom}</span>
        </div>
        <div className="token1_input">
          <div>
            Available{" "}
            <div className="token-balance-wrapper">
              <GetBalance
                token={token1.display_denom}
                fetchBal={() => {}}
                customCss="addLiquidity-getbalance"
                settokenBal={setToken1Bal}
                dataRefetch = {dataRefetch}
              />
            </div>{" "}
            {token1.display_denom}{" "}
          </div>
          <div className="max-wrapper" onClick={handleMax}>
            <p>MAX</p>
          </div>
          <input
            className="manual-percent"
            type="number"
            value={input1}
            onChange={handleinput1}
            placeholder="0.0000"
            autoFocus={true}
            disabled={disabled}
          />
        </div>
      </div>
      <div className="token1-wrapper">
        <div className="token_info">
          <div>
            {<img src={token2?.logo_URIs.png} alt="NOimg" height={50} />}
          </div>
          <span>{token2.display_denom}</span>
        </div>
        <div className="token1_input">
          <div>
            Available{" "}
            <div className="token-balance-wrapper">
              <GetBalance
                token={token2.display_denom}
                fetchBal={() => {}}
                customCss="addLiquidity-getbalance"
                settokenBal={setToken2Bal}
              />
            </div>{" "}
            {token2.display_denom}
          </div>
          <input
            className="manual-percent"
            type="number"
            value={input2}
            onChange={handleinput2}
            placeholder="0.0000"
            disabled={disabled}
          />
        </div>
      </div>
      <div
        className={`pool-holding-button liquidity-btn ${
          !address
            ? ""
            : !Number(input1) ||
              !Number(input2) ||
              Number(input1) > token1Bal ||
              Number(input2) > token2Bal
            ? "disabled-button"
            : ""
        }`}
        onClick={
          address
            ? !Number(input1) ||
              !Number(input2) ||
              Number(input1) > token1Bal ||
              Number(input2) > token2Bal
              ? () => {}
              : handleAddLiquidity
            : connectWallet
        }
      >
        {address
          ? !Number(input1) || !Number(input2)
            ? "Amount is zero"
            : Number(input1) > token1Bal || Number(input2) > token2Bal
            ? "Insufficient Balance"
            : "Add Liquidity"
          : "Connect Wallet"}
      </div>

      <LoadingModal
        content={["Adding Liquidity", `${pairs.pair_name}`]}
        isOpen={isLoading}
      />
    </div>
  );
};

export default AddLiquidity;
